/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum WebClientType {
    Undefined = 0,
    Recorder = 1,
    Player = 2,
    ViewingStation = 3,
    Tablet = 4,
    TrainingRoomEntrance = 5,
    System = 6,
    External = 7,
    MoC = 8,
}
